let fromBase64 = null;

if (typeof window === "undefined") {
	fromBase64 = str => Buffer.from(str, "base64").toString("utf-8");
} else {
	fromBase64 = base64String => {
		// We got an issue with Cyrilic letters in the token payload
		// the solution is described in the gitgub:
		//
		// https://github.com/GoogleChromeLabs/web-push-codelab/issues/92#issuecomment-555805077
		const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
		const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
		return window.atob(base64);
	};
}

/**
 * Parses JWT and returns the token payload
 *
 * @type {(jwt: string | null | undefined) => string | null}
 */
export const jwtPayload = jwt => {
	if (jwt == null) return null;
	try {
		return JSON.parse(fromBase64(jwt.split(".")[1]));
	} catch (err) {
		return null;
	}
};

/** @type {(token: { exp: number }) => boolean} */
export const isNotExpired = token => token && token.exp * 1000 > Date.now();

/** @type {(token: string) => boolean} */
export const isTokenValid = token => Boolean(token) && jwtPayload(token) != null;
